
import BillingApp from "../assets/bill.png";
import YouTube from "../assets/youtube.jpg";

import python from "../assets/python.jpg";



const ProjectcardData=[
    {
        imgsrc:"https://images-platform.99static.com//ho7seGpM432Mtu2oc9qnsax93gQ=/0x0:1540x1540/fit-in/500x500/99designs-contests-attachments/118/118889/attachment_118889619",
        title:"Chatting-Website",
        software:"Reactjs,Nodejs and Socket.Io",
        text:"Chatting app allows you to communicate with your customers in web chat rooms. It enables you to send and receive messages.",
        view:"https://chatapplication18.netlify.app/",
        source:"https://github.com/pavithradeevi/Chat-App---Frontend",
        backend:"https://github.com/pavithradeevi/Chat--App---Backend",
        
       
    },
    {
        imgsrc:"https://i.pinimg.com/originals/a2/6e/42/a26e42330d1517409842ff321f1fa906.png",
        title:"Pizza Order Website",
        software:"ReactJS,NodeJS,MongoDB,Redux and JWT",
        text:"An food ordering website that allows customers to view the price and place an order.",
        view:"https://pizzaselling18.netlify.app",
        source:"https://github.com/pavithradeevi/pizzashop-frontend",
        backend:"https://github.com/pavithradeevi/Pizza-Shop-Backend",
    },
    {
        imgsrc:"https://themewagon.com/wp-content/uploads/2018/12/royalestate-1.jpg",
        title:"Real Estate",
        software:"Reactjs,Nodejs and MongoDB",
        text:"Our software covers all real estate sectors such as Village house,Mountain House and many more.It will use to connect owner easily.",
        view:"https://realestate18.netlify.app",
        source:"https://github.com/pavithradeevi/Real-Estate---Frontend",
        backend:"https://github.com/pavithradeevi/Real-Estate---Backend"
    },
    {
        imgsrc:"https://indian-retailer.s3.ap-south-1.amazonaws.com/s3fs-public/2020-07/loaf.jpg",
        title:"Ecommerce Website",
        software:"Reactjs,Nodejs and MongoDB",
        text:"Its includes womens clothing, such as kurtas, sleepwear as well as accessories, such as jewelry selling and easily make payments.",
        view:"https://ecommercewebsite18.netlify.app/",
        source:"https://github.com/pavithradeevi/Clothing-Website---Frontend",
        backend:"https://github.com/pavithradeevi/Clothing-Website---backend"
        
    },
    
    // {
    //     imgsrc:"https://images04.nicepage.com/feature/461183/website-blog.jpg",
    //     title:"Blog",
    //     software:"ReactJS,NodeJS,MongoDB",
    //     text:"Posts are typically displayed in reverse chronological order so that the most recent post appears first, at the top of the web page.",
    //     view:"https://dazzling-dasik-a8211d.netlify.app/",
    //     source:"https://github.com/pavithradeevi/Blog---Frontend",
    //     backend:"https://github.com/pavithradeevi/Blog---Backend"
    // },
    
   
    {
        imgsrc:YouTube,
        title:"YouTubeClone - Frontend",
        software:"HTML,CSS and API",
        text:"YouTube Clone is an video-sharing solution that aids you in launching your video streaming software that has the power to rival YouTube itself.",
        view:"https://youtubeclone18.netlify.app/",
        source:"https://github.com/pavithradeevi/YouTube",
        backend:"https://github.com/pavithradeevi/YouTube"
        
    },
    {
        imgsrc:python,
        title:"Face Recognition System - Backend",
        software:"Python,ML and SQL",
        text:"Facial recognition can identify human faces in images or videos, search for a face among a large collection of existing images.",
        view:"https://dazzling-dasik-a8211d.netlify.app/",
        source:"https://github.com/pavithradeevi/Face-Recognition-attendance-System-using-MYSQL",
        backend:"https://github.com/pavithradeevi/Face-Recognition-attendance-System-using-MYSQL"
    },

];

export default ProjectcardData;